import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseGenerico } from '../model/response-generico';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BitacoraService {

  headers = new HttpHeaders();
  public laravelapi;
  public laravelapiStorage;
  constructor(
    protected _http:HttpClient,
    private _config:ConfigurationService
  ){
      this.laravelapi = _config.getConfiguration().laravelapi;
      this.laravelapiStorage = _config.getConfiguration().laravelapiStorage;
      console.log(this.laravelapi);
      console.log(this.laravelapiStorage);
  }
  public getLaravelApiStorage(){
    return this.laravelapiStorage;
  }

  public getLaravelApi(){
    return this.laravelapi;
  }

 
  public getConsultaBitacoras(p: number, r: number, id_per: number):any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/ConsultaBitacoras?filas="+r+'&page='+p+'&numero_periodo='+id_per);
  }

  public getConsultaPeriodosBitacora(r: number):any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/ConsultaPeriodosBitacora?filas="+r);
  }

  public getConsultarBitacora(id: number):any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/ConsultarBitacora?numero_bitacora="+id);
  }

  public postModificarBitacoras(datos: any):any{
    return this._http.post<ResponseGenerico>(this.laravelapi+"/ModificarBitacoras", datos, {});
  }

  public getNuevaBitacora(id: any):any{
    return this._http.get<ResponseGenerico>(this.laravelapi+"/NuevaBitacora?numero_periodo="+id, {});
  }




  

 

  
  

  



  
}
